import "./Events.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
  Typography,
  Pagination,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import {
  CheckCircleFilled,
  DeleteOutlined,
  FormOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  EventstRaw,
  EventtMessages,
  PageSetting,
  Query,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/events/get-event-actions";
import {
  findById,
  update,
} from "../../../../controllers/store/actions/events/update-event-actions";
import { remove } from "../../../../controllers/store/actions/events/delete-event-action";
import { clear } from "../../../../controllers/store/actions/events/create-event-action";
import NewEventModal from "../../../components/Forms/Modal/Events/NewEvent";
import UpdateEventModal from "../../../components/Forms/Modal/Events/UpdateEvent";
import Paragraph from "antd/es/typography/Paragraph";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Events: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const eventsState = useSelector((state: any) => state.events);
  const updatedEventState = useSelector((state: any) => state.updatedEvent);
  const deletedEventState = useSelector((state: any) => state.deletedEvent);
  const createdEventState = useSelector((state: any) => state.createdEvent);
  const userState = useSelector((state: any) => state.user.user);

  const columns: TableProps<EventstRaw>["columns"] = [
    {
      title: "Nombre del evento",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Descripción del evento",
      dataIndex: "description",
      key: "description",
      render(value, record, index) {
        return (
          <Paragraph
            ellipsis={{ rows: 2, expandable: true, symbol: " leer más" }}
          >
            {value}
          </Paragraph>
        );
      },
    },
    {
      title: "Tipo de evento",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Organizador",
      dataIndex: "organizer_fullname",
      key: "organizer_fullname",
    },
    {
      title: "Fecha de inicio de evento",
      dataIndex: "visibility_start_date",
      key: "visibility_start_date",
    },
    {
      title: "Fecha de finalización de evento",
      dataIndex: "visibility_end_date",
      key: "visibility_end_date",
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
    },
    {
      title: "Fecha de creación",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Última actualización",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 350,
      render: (_, record: EventstRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record && record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if (record && record.id) {
                confirm({
                  okType: "primary",
                  okText: "Publicar",
                  cancelText: "Cancelar",
                  title: EventtMessages.Title,
                  content: EventtMessages.EventPublished,
                  onOk: async () => {
                    if (record.id) {
                      try {
                        await dispatch(
                          update(record.id, {
                            status:
                              record.status === "Published"
                                ? "Draft"
                                : "Published",
                          })
                        );
                        query.filter.user = `&filter[user_created][_eq]=${userState.me.id}&deep=true&sort=-created_at`;
                        dispatch(find(page || 1, pageSize, query));
                      } catch (error) {
                        console.error("Error al actualizar el evento", error);
                      }
                    }
                  },
                  onCancel() {},
                });
              }
            }}
            size="small"
            icon={
              record.status === "Published" ? (
                <DeleteOutlined />
              ) : (
                <CheckCircleFilled twoToneColor={"#28A745"} color="#28A745" />
              )
            }
          >
            {record.status === "Published" ? "Quitar publicación" : "Publicar"}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: EventtMessages.Title,
                content: EventtMessages.EventsConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedEventMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: EventtMessages.Title,
      description: EventtMessages.EventCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedEventMessage = () => {
    api["success"]({
      key: 1,
      message: EventtMessages.Title,
      description: EventtMessages.EventsDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedEventMessage = () => {
    api["success"]({
      key: 1,
      message: EventtMessages.Title,
      description: EventtMessages.EventUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    query.filter.user = `&filter[user_created][_eq]=${userState.me.id}&deep=true&sort=-created_at`;
    dispatch(find(1, pageSize, query));
  }, [pageSize]);

  return (
    <Layout className="announcement-layout">
      {contextHolder}
      {createdEventState.createdSearcher
        ? showCreatedEventMessageSuccess()
        : null}
      {deletedEventState.removed ? showDeletedEventMessage() : null}
      {updatedEventState.updatedSearcher ? showUpdatedEventMessage() : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="announcement-content">
        <Card className="announcement-card">
          <NewEventModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateEventModal
            event={updatedEventState.event}
            visible={visibleUpdateModal}
            onUpdated={() => {
              console.log("events updated", updatedEventState);
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />
          <Skeleton
            loading={eventsState.isLoading}
            active
            className="full-width"
          >
            {eventsState?.list?.length === 0 ? (
              <>
                <br />
                <br />
                <br />
                <br />
                <Empty
                  image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                  imageStyle={{ height: 60 }}
                  description={<span>No tienes eventos aún</span>}
                >
                  <Button
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setVisibleCreateModal(!visibleCreateModal);
                    }}
                    type="primary"
                  >
                    Agregar evento
                  </Button>
                </Empty>
                <br />
                <br />
                <br />
                <br />
              </>
            ) : (
              <>
                <h1 className="heading-content-title">Eventos</h1>
                <br />
                <Row
                  gutter={[8, 8]}
                  style={{ width: "100%", marginBottom: 20 }}
                >
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <Flex vertical={true} align={"flex-start"}>
                      <Search
                        placeholder="Buscar"
                        onSearch={(value: string) => {
                          if (value) {
                            query.filter.text = `&search=${value}`;
                            query.meta = `filter_count`;
                            query.sort = [
                              { field: "date_created", mode: SortMode.ASC },
                            ];
                            return dispatch(find(1, pageSize, query));
                          }

                          dispatch(find(1, PageSetting.limit, {} as Query));
                        }}
                        enterButton
                      />
                    </Flex>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <Flex vertical={true} align={"flex-end"}>
                      <Button
                        type="primary"
                        onClick={() =>
                          setVisibleCreateModal(!visibleCreateModal)
                        }
                        size="middle"
                        icon={<PlusOutlined />}
                      >
                        Agregar evento
                      </Button>
                    </Flex>
                  </Col>
                </Row>
                <Table
                  scroll={{ x: 1200 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      eventsState?.meta?.total_count ||
                      eventsState.meta.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={eventsState.list}
                />
              </>
            )}
          </Skeleton>
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Events;
